import { atom } from 'jotai';

import { DisplayMode } from '../types/display-mode';

export const displayModeState = atom<DisplayMode>(DisplayMode.SELECTED);
